import { render, staticRenderFns } from "./CustomersGeneralFilterClassic.vue?vue&type=template&id=4d0dfe6d&"
import script from "./CustomersGeneralFilterClassic.vue?vue&type=script&lang=js&"
export * from "./CustomersGeneralFilterClassic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports